"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var jss_1 = __importDefault(require("jss"));
var jss_preset_default_1 = __importDefault(require("jss-preset-default"));
var compat_1 = require("preact/compat");
var clsx_1 = __importDefault(require("clsx"));
var HorizontalMoreOptions_1 = __importDefault(require("./icons/HorizontalMoreOptions"));
var VerticalMoreOptions_1 = __importDefault(require("./icons/VerticalMoreOptions"));
var ExportMoreOptions_1 = __importDefault(require("./icons/ExportMoreOptions"));
var TooltipArrow_1 = __importDefault(require("./icons/TooltipArrow"));
var constant_1 = require("./constant");
var locale_1 = require("./locale");
// One time setup with default plugins and settings.
jss_1.default.setup((0, jss_preset_default_1.default)());
var localeStrings = (0, locale_1.getLocaleStrings)();
var classes = jss_1.default
    .createStyleSheet({
    modal: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        zIndex: 100,
        touchAction: 'none',
    },
    backdrop: {
        zIndex: -1,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    contentWrapper: {
        padding: '0 24px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    emoji: {
        fontSize: 60,
        lineHeight: '60px',
    },
    alertSentence1: {
        fontSize: 16,
        lineHeight: '24px',
        color: '#FFF',
        fontWeight: 600,
        textAlign: 'center',
        marginTop: 16,
    },
    alertSentence2: {
        fontSize: 14,
        lineHeight: '18px',
        color: '#FFF',
        fontWeight: 400,
        textAlign: 'center',
        marginTop: 8,
    },
    hintWrapper: {
        maxWidth: 'calc(100% - 16px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        right: 8,
    },
    hintWrapperTop: {
        position: 'absolute',
        top: 20,
    },
    hintWrapperBottom: {
        position: 'absolute',
        bottom: 20,
    },
    dialogWrapper: {
        borderRadius: 8,
        padding: '8px 16px',
        backgroundColor: '#2962FF',
        position: 'relative',
    },
    dialogText: {
        fontFamily: 'Roboto, sans-serif',
        fontSize: 16,
        lineHeight: '24px',
        color: '#FFF',
        fontWeight: 400,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        margin: 0,
        flexWrap: 'wrap',
    },
    icon: {
        width: 24,
        height: 24,
    },
    exportMoreIcon: {
        width: 16,
        height: 16,
        paddingLeft: 8,
        paddingRight: 8,
    },
    arrowTopWrapper: {
        display: 'flex',
        position: 'absolute',
        bottom: 'calc(100% - 1px)',
        right: 12,
    },
    arrowBottomWrapper: {
        display: 'flex',
        position: 'absolute',
        top: 'calc(100% - 1px)',
        right: 12,
        transform: 'rotate(180deg) scaleX(-1)',
    },
    currentUrlWrapper: {
        display: 'flex',
        flexDirection: 'row',
        borderRadius: 8,
        width: 'calc(100% - 48px)',
        backgroundColor: 'white',
        padding: 4,
        marginTop: 24,
    },
    currentUrlInput: {
        height: 40,
        flex: 1,
        minWidth: 0,
        border: 'none',
        userSelect: 'all',
        borderRadius: 8,
        fontSize: 16,
        lineHeight: '24px',
        '&:focus': {
            outline: 'none',
        },
    },
    currentUrlBtn: {
        flexShrink: 0,
        border: 0,
        color: '#2962FF',
        fontSize: 16,
        lineHeight: '24px',
        backgroundColor: 'transparent',
        padding: '8px 16px',
    },
    currentUrlBtnCopied: {
        color: '#5FC417',
    },
})
    .attach().classes;
var DisplayMode;
(function (DisplayMode) {
    DisplayMode["HINT"] = "hint";
    DisplayMode["COPY"] = "copy";
})(DisplayMode || (DisplayMode = {}));
function getHintImage(platform, browser) {
    if (platform === 'ios') {
        switch (browser) {
            case 'facebook':
                return (0, jsx_runtime_1.jsx)(HorizontalMoreOptions_1.default, { className: classes.icon });
            case 'instagram':
                return (0, jsx_runtime_1.jsx)(HorizontalMoreOptions_1.default, { className: classes.icon });
            case 'line':
                return (0, jsx_runtime_1.jsx)(VerticalMoreOptions_1.default, { className: classes.icon });
            case 'messenger':
                return (0, jsx_runtime_1.jsx)(ExportMoreOptions_1.default, { className: classes.exportMoreIcon });
            default:
        }
    }
    if (platform === 'android') {
        switch (browser) {
            case 'facebook':
                return (0, jsx_runtime_1.jsx)(HorizontalMoreOptions_1.default, { className: classes.icon });
            case 'instagram':
                return (0, jsx_runtime_1.jsx)(VerticalMoreOptions_1.default, { className: classes.icon });
            case 'line':
                return (0, jsx_runtime_1.jsx)(VerticalMoreOptions_1.default, { className: classes.icon });
            case 'messenger':
                return (0, jsx_runtime_1.jsx)(VerticalMoreOptions_1.default, { className: classes.icon });
            default:
        }
    }
    return (0, jsx_runtime_1.jsx)(HorizontalMoreOptions_1.default, { className: classes.icon });
}
function getHintBrowserString(platform, browser) {
    if (platform === 'ios') {
        switch (browser) {
            case 'facebook':
                return localeStrings.openInSystemBrowser; // open in system browser
            case 'instagram':
                return localeStrings.openInSystemBrowser; // open in system browser
            case 'line':
                return localeStrings.openInBrowser; // open in browser
            case 'messenger':
                return localeStrings.openInSafari; // open in safari
            default:
        }
    }
    if (platform === 'android') {
        switch (browser) {
            case 'facebook':
                return localeStrings.openInSystemBrowser; // open in system browser
            case 'instagram':
                return localeStrings.openInChrome; // Open in Chrome
            case 'line':
                return localeStrings.openInDefaultBrowser; // open in your default browser
            case 'messenger':
                return localeStrings.openInChrome; // Open in Chrome
            default:
        }
    }
    return localeStrings.openInSystemBrowser; // open in system browser
}
function getPlatform(userAgent) {
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return 'windows';
    }
    if (/android/i.test(userAgent)) {
        return 'android';
    }
    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
    }
    return 'unknown';
}
function getAndroidFacebookBrowser(userAgent) {
    if (/Orca-Android/i.test(userAgent)) {
        return 'messenger';
    }
    return 'facebook';
}
function getArrowPosition(platform, browser) {
    if (platform === 'ios') {
        switch (browser) {
            case 'facebook':
                return 'bottom';
            case 'instagram':
                return 'top';
            case 'line':
                return 'bottom';
            case 'messenger':
                return 'bottom';
            default:
        }
    }
    if (platform === 'android') {
        switch (browser) {
            case 'facebook':
                return 'top';
            case 'instagram':
                return 'top';
            case 'line':
                return 'bottom';
            case 'messenger':
                return 'top';
            default:
        }
    }
    return null;
}
function isBlurSupported() {
    // https://developer.mozilla.org/en-US/docs/Web/API/CSS/supports
    // https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter#Browser_compatibility
    return (typeof CSS !== 'undefined' &&
        (CSS.supports('-webkit-backdrop-filter', 'blur(1px)') || CSS.supports('backdrop-filter', 'blur(1px)')));
}
var LeaveInAppBrowserModal = (0, compat_1.memo)(function (props) {
    var inApp = props.inApp, options = props.options;
    var _a = options || {}, optionsRedirectUrl = _a.redirectUrl, _b = _a.shouldAlwaysShowCopyUI, shouldAlwaysShowCopyUI = _b === void 0 ? false : _b;
    var redirectUrl = optionsRedirectUrl || window.location.href;
    var platform = getPlatform(inApp.ua);
    var currentBrowser = platform === 'android' && inApp.browser === 'facebook' ? getAndroidFacebookBrowser(inApp.ua) : inApp.browser;
    var arrowPosition = getArrowPosition(platform, currentBrowser);
    var hintWrapperClass = (function () {
        switch (arrowPosition) {
            case 'top':
                return (0, clsx_1.default)(classes.hintWrapper, classes.hintWrapperTop);
            case 'bottom':
            default:
                return (0, clsx_1.default)(classes.hintWrapper, classes.hintWrapperBottom);
        }
    })();
    (0, compat_1.useEffect)(function () {
        var body = document.querySelector('body');
        if (body) {
            body.style.overflow = 'hidden';
        }
    }, []);
    var blurStyle = (0, compat_1.useMemo)(function () {
        if (isBlurSupported()) {
            return {
                backdropFilter: 'saturate(180%) blur(10px)',
                WebKitBackdropFilter: 'saturate(180%) blur(10px)',
            };
        }
        return {};
    }, []);
    var _c = (0, compat_1.useState)(false), copied = _c[0], setCopied = _c[1];
    var _d = (0, compat_1.useState)(false), copyFailed = _d[0], setCopyFailed = _d[1];
    var copyFn = (0, compat_1.useCallback)(function (manual) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var text, resolve, reject, textarea;
        return __generator(this, function (_a) {
            text = redirectUrl;
            if (typeof navigator !== undefined && typeof navigator.clipboard !== undefined) {
                resolve = function () {
                    if (manual) {
                        setCopied(true);
                    }
                };
                reject = function (err) {
                    console.error("\u900F\u904E Clipboard \u8907\u88FD\u81F3\u526A\u8CBC\u7C3F\u5931\u6557:".concat(err.toString()));
                    setCopyFailed(true);
                };
                navigator.clipboard.writeText(text).then(resolve, reject);
            }
            else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
                try {
                    textarea = document.createElement('textarea');
                    textarea.value = text;
                    textarea.style.display = 'none';
                    document.body.appendChild(textarea);
                    textarea.focus();
                    textarea.select();
                    document.execCommand('copy');
                    document.body.removeChild(textarea);
                    if (manual) {
                        setCopied(true);
                    }
                }
                catch (e) {
                    setCopyFailed(true);
                }
            }
            return [2 /*return*/];
        });
    }); }; }, [redirectUrl]);
    var displayMode = shouldAlwaysShowCopyUI || !arrowPosition ? DisplayMode.COPY : DisplayMode.HINT;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ id: constant_1.LEAVE_IAB_MODAL_ID, className: classes.modal }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.backdrop, style: blurStyle }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.contentWrapper }, { children: [(0, jsx_runtime_1.jsx)("img", { src: "data:image/png;base64, ".concat(constant_1.doubleBrowserIcons), alt: "browser", style: { width: 120, height: 120 } }), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.alertSentence1 }, { children: localeStrings.alertSentence1 })), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.alertSentence2 }, { children: localeStrings.alertSentence2 })), displayMode === DisplayMode.COPY && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.currentUrlWrapper }, { children: [(0, jsx_runtime_1.jsx)("input", { readOnly: true, value: redirectUrl, className: classes.currentUrlInput }), !copyFailed && ((0, jsx_runtime_1.jsx)("button", __assign({ type: "button", className: (0, clsx_1.default)([classes.currentUrlBtn, copied ? classes.currentUrlBtnCopied : undefined]), onClick: copyFn(true) }, { children: copied ? localeStrings.copied : localeStrings.copy })))] })))] })) })), displayMode === DisplayMode.HINT && ((0, jsx_runtime_1.jsx)("div", __assign({ className: hintWrapperClass }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.dialogWrapper }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: classes.dialogText }, { children: [localeStrings.hintPart1, getHintImage(platform, currentBrowser), localeStrings.hintPart2, getHintBrowserString(platform, currentBrowser), localeStrings.hintPart3] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: arrowPosition === 'top' ? classes.arrowTopWrapper : classes.arrowBottomWrapper }, { children: (0, jsx_runtime_1.jsx)(TooltipArrow_1.default, {}) }))] })) })))] })));
});
exports.default = LeaveInAppBrowserModal;
